import React from 'react'
import PropTypes from 'prop-types'

import { Node } from 'components'
import FooterNav from '../FooterNav'
import TrailPresentation from '../TrailPresentation'

import styles from './MainContent.module.css'

const MainContent = ({ items, prevItem, nextItem, currentItem, presentation }) => {
  const node = items.find(({ nid }) => nid === currentItem)

  return (
    <main className={styles.main}>
      <div className={styles.inner}>
        {!currentItem && presentation ? (
          <TrailPresentation presentation={presentation} />
        ) : (
          <>
            <Node node={node} />
            <FooterNav nextItem={nextItem} prevItem={prevItem} presentation={presentation} />
          </>
        )}
      </div>
    </main>
  )
}

MainContent.propTypes = {
  items: PropTypes.array,
  currentItem: PropTypes.number,
  prevItem: PropTypes.shape({
    nid: PropTypes.number,
    title: PropTypes.string,
    pos: PropTypes.number,
  }),
  nextItem: PropTypes.shape({
    nid: PropTypes.number,
    title: PropTypes.string,
    pos: PropTypes.number,
  }),
  presentation: PropTypes.array,
}

export default MainContent
